/* eslint-disable no-param-reassign */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable max-params */
/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React, { useEffect, useRef, useState } from 'react';
import {
  Alert,
  ButtonPrimary,
  Button,
  dlsBrightBlue,
  IconSetting,
  ButtonSecondary,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Tooltip,
  TooltipButton,
} from '@americanexpress/dls-react';
import _ from 'lodash';
// eslint-disable-next-line import/no-extraneous-dependencies
import { callFxgApi } from '../../../../utils/callFxgApi'
import { ItemsPerPageBadges } from './EnhancedTableToolbarCommon';
import { useEnhancedDataTableContext } from '../EnhancedDataTableContext';
import multiSelectStyle from '../../../styles/EnhancedTableToolbar/MultiItemSelect';
import {
  getActiveHeader,
  getInActiveHeader,
  getOptionsForMultiSelect,
  getPreferenceOrder,
  getSNoToHeaderMap,
} from '../DataTableHeaderUtil';
import ConfirmUserPopup from '../../ConfirmUserPopup/ConfirmUserPopup';
// eslint-disable-next-line import/named
import { SORTING } from '../EnhanceDataTableUtil';
import MultiItemSelect from '../../MultiItemSelect';
import paths from '../../../constants/paths';

const TableSettingsComponent = React.memo((props) => {
  const context = useEnhancedDataTableContext();

  const { tableNm } = context;
  const { setItemActionClicked } = props;

  const [settingsModalIsOpen, setSettingsModalIsOpen] = useState(false);
  const [iconFilled, setIconFilled] = useState(false);

  const handleToolTipBtnClick = () => {
    setSettingsModalIsOpen(true);
    setItemActionClicked(false);
  };
  return (
    <div id={`${tableNm}-table-settings-component`} style={{ display: 'inline-block' }}>
      {/* <div> */}
      <Tooltip
        id={`${tableNm}-table-settings-button-tooltip`}
        triggerElement={(
          <TooltipButton
            id={`${tableNm}-table-settings-button`}
            icon={(
              <IconSetting
                size="md"
                theme={dlsBrightBlue}
                title="Table Settings"
                filled={iconFilled}
              />
            )}
            onMouseOver={() => {
              setIconFilled(true);
            }}
            onMouseOut={() => {
              setIconFilled(false);
            }}
            onClick={handleToolTipBtnClick}
          />
        )}
        placement="top"
        forcePlacement={true}
      >
        Table Settings
      </Tooltip>

      {settingsModalIsOpen && (
        <TableSettingsPopup
          key={settingsModalIsOpen}
          setSettingsModalIsOpen={setSettingsModalIsOpen}
          {...props}
        />
      )}

      {/* )} */}
      {/* </div> */}
      {/* </div> */}
    </div>
  );
});

const TableSettingsPopup = (props) => {
  const context = useEnhancedDataTableContext();
  const maxColumn = useRef(12);
  const {
    onTableSettingsChange, setSettingsModalIsOpen, onTableSettingResetToDefault,
  } = props;

  const { defaultTableSettings } = context;
  const { tableNm } = context;
  const { headers } = context;
  const sortEnable = context.sortable;
  const { sortBy } = context;
  const { tableData } = context;
  const { loginData } = context;
  const { apiHostService } = context;
  const { dispatch } = context;

  const [changeFlag, setChangeFlag] = useState(false);
  const [askForConfirmation, setAskForConfrimation] = useState(false);
  const [error, setError] = useState(false);
  const [itemsPerPage, setItemPerPage] = useState(context.itemsPerPage);
  const [sortDirection, setSortDirection] = useState(context.sortDirection);
  const [isMinOneActHeaderErr, setIsMinOneActHeaderErr] = useState(false);
  const [isExceedingLimitErr, setIsExceedingLimitErr] = useState(false);

  const headerMap = getSNoToHeaderMap(headers);
  const preferenceOrder = getPreferenceOrder(headers);
  const activeHeader = getActiveHeader(headers);
  const inactiveHeader = getInActiveHeader(headers);
  const [options, setOptions] = useState(
    getOptionsForMultiSelect(preferenceOrder, headerMap, activeHeader, inactiveHeader)
  );

  const isSortByDateType = () => headers.filter((ele) => ele.id === sortBy && ele.type === 'date').length > 0;
  const sortByLabel = headers.find((h) => h.id === sortBy)?.label;
  const [sorting] = useState(() => {
    if (isSortByDateType() && tableData.enableDateSorting === true) {
      if (sortDirection === 'asc') {
        setSortDirection(SORTING.oldest.name);
      } else if (sortDirection === 'desc') {
        setSortDirection(SORTING.latest.name);
      }
      return [SORTING.latest, SORTING.oldest];
    }
    return [SORTING.asc, SORTING.desc];
  });

  // eslint-disable-next-line complexity
  const validateForChange = (
    newItemPerPage = itemsPerPage,
    newSortDirection = sortDirection,
    newOption = options,
    rightOption = []
  ) => {
    const newActiveHeader = newOption
      .filter((item) => item.selected === true)
      .map((item) => item.key);

    const newInActiveHeader = newOption
      .filter((item) => item.selected === false)
      .map((item) => item.key);

    const newRightOption = rightOption
      .map((item) => item.key);

    const columnChangeFlag = activeHeader.toString() !== newActiveHeader.toString()
      || inactiveHeader.toString() !== newInActiveHeader.toString()
      || (rightOption.length > 0 && newActiveHeader.toString() !== newRightOption.toString());

    const otherSettingFlag = context.itemsPerPage !== newItemPerPage || context.sortDirection !== newSortDirection;

    if (otherSettingFlag && !columnChangeFlag) {
      setChangeFlag(true);
    } else if (!otherSettingFlag && columnChangeFlag) {
      if (rightOption.length > 0) {
        setChangeFlag(rightOption?.length > 0 && rightOption?.length <= maxColumn.current);
      } else {
        setChangeFlag(newActiveHeader.length > 0);
      }
    } else if (otherSettingFlag && columnChangeFlag) {
      if (rightOption.length > 0) {
        setChangeFlag(rightOption?.length > 0 && rightOption?.length <= maxColumn.current);
      } else {
        setChangeFlag(newActiveHeader.length > 0);
      }
    } else {
      setChangeFlag(false);
    }
  };

  const onItemsPerPageChange = (n) => {
    setItemPerPage(n);
    validateForChange(n, sortDirection, options);
  };

  const onSortDirectionChange = (newDirection) => {
    setSortDirection(newDirection);
    validateForChange(itemsPerPage, newDirection, options);
  };

  const onChangeOfMultiItem = (_leftOption, rightOption) => {
    if (rightOption?.length < 1) {
      setIsMinOneActHeaderErr(true);
    } else {
      setIsMinOneActHeaderErr(false);
    }
    setIsExceedingLimitErr(rightOption?.length > maxColumn.current);
    validateForChange(itemsPerPage, sortDirection, options, rightOption);
  };

  const onRightItemMove = (itemsToMoveArr, rightOption, leftOption) => {
    if (itemsToMoveArr?.length >= rightOption?.length) {
      const newRightOption = itemsToMoveArr.map((item) => ({
        ...item,
      }));
      setOptions([...leftOption, ...newRightOption]);
      setIsMinOneActHeaderErr(true);
    }
    setOptions([...leftOption, ...rightOption]);
  };
  const onLeftItemMove = (itemsToMoveArr, rightOption, leftOption) => {
    if (rightOption?.length + itemsToMoveArr.length > maxColumn.current) {
      const newLeftOption = leftOption.map((item) => ({
        ...item,
      }));
      setOptions([...newLeftOption, ...rightOption]);
      setIsExceedingLimitErr(true);
    } else {
      setIsExceedingLimitErr(false);
      setOptions([...leftOption, ...rightOption]);
      setChangeFlag(true);
    }
  };

  const savePreferenceDataInDB = async (
    newOptions,
    newItemsPerPage,
    newSortDirection,
    newSortBy
  ) => {
    const newHeaderOrder = newOptions.map((item) => item.key);
    const newActiveHeader = newOptions
      .filter((item) => item.selected === true)
      .map((item) => item.key);
    const newInActiveHeader = newOptions
      .filter((item) => item.selected === false)
      .map((item) => item.key);

    const newPreferenceData = {
      order: newHeaderOrder,
      activeHeader: newActiveHeader,
      inactiveHeader: newInActiveHeader,
      itemsPerPage: newItemsPerPage,
      sortDirection: newSortDirection,
      sortBy: newSortBy,
      tableNm,
    };

    const settingData = {
      tableNm,
      preferenceData: newPreferenceData,
    };

    setIsMinOneActHeaderErr(false);

    // TODO: must not be specific to only access-management
    const { hasErrors } = await callFxgApi(
      `${apiHostService}${paths.apiPaths.fxgSaveUserPreferenceData}`,
      'POST',
      settingData
    );

    return { isError: hasErrors, newPreferenceData };
  };

  const updateLoginData = (newPreferenceData) => {
    const newLoginData = { ...loginData };

    const isPrefrenceDataPresent = newLoginData.preferenceData.tableData.some(
      (data) => data.tableNm === newPreferenceData.tableNm);

    if (!isPrefrenceDataPresent) {
      newLoginData.preferenceData.tableData.push(newPreferenceData);
    } else {
      const prefrenceDataIndex = newLoginData.preferenceData?.tableData.findIndex(
        (data) => data.tableNm === newPreferenceData.tableNm);
      newLoginData.preferenceData.tableData[prefrenceDataIndex] = newPreferenceData;
    }

    if (dispatch) {
      dispatch({ type: 'LOGIN_SUCCEEDED', data: newLoginData });
    }
  };

  // eslint-disable-next-line consistent-return
  const onResetToDefaultClick = async () => {
    setIsMinOneActHeaderErr(false);
    if (defaultTableSettings) {
      const newTableData = { ...tableData };
      newTableData.headers = _.cloneDeep(defaultTableSettings.headers);
      newTableData.sortBy = defaultTableSettings.sortBy;
      newTableData.itemsPerPage = defaultTableSettings.itemsPerPage;
      newTableData.sortDirection = defaultTableSettings.sortDirection;
      const newHeaderMap = getSNoToHeaderMap(newTableData.headers);
      const newPreferenceOrder = getPreferenceOrder(newTableData.headers);
      const newActiveHeader = getActiveHeader(newTableData.headers);
      const newInactiveHeader = getInActiveHeader(newTableData.headers);
      const newOptions = getOptionsForMultiSelect(
        newPreferenceOrder,
        newHeaderMap,
        newActiveHeader,
        newInactiveHeader
      );
      const { isError, newPreferenceData } = await savePreferenceDataInDB(
        newOptions,
        newTableData.itemsPerPage,
        newTableData.sortDirection,
        newTableData.sortBy
      );
      if (isError) {
        setError(true);
      } else {
        setSettingsModalIsOpen(false);
        if (onTableSettingsChange) {
          // for now ...
          onTableSettingResetToDefault(newPreferenceData, newTableData);
          updateLoginData(newPreferenceData);
        }
      }
    } else {
      return null;
    }
  };

  const onUserConfirm = () => {
    setAskForConfrimation(false);
    setSettingsModalIsOpen(false);
  };

  const onUserDeny = () => {
    setAskForConfrimation(false);
  };

  const onClose = () => {
    if (changeFlag) {
      setAskForConfrimation(true);
    } else {
      setSettingsModalIsOpen(false);
    }
  };

  const onSave = async () => {
    // options.sort((a, b) => a.rank - b.rank);
    // console.log('options in on save', options);
    const { isError, newPreferenceData } = await savePreferenceDataInDB(
      options,
      itemsPerPage,
      sortDirection,
      sortBy
    );

    if (isError) {
      setError(true);
    } else {
      if (onTableSettingsChange) {
        // for now ...
        onTableSettingsChange(newPreferenceData);
        updateLoginData(newPreferenceData);
      }
      setSettingsModalIsOpen(false);
    }
  };

  return (
    <div style={{ userSelect: 'none' }}>
      <ConfirmUserPopup
        displayPopup={askForConfirmation}
        onConfirm={onUserConfirm}
        onDeny={onUserDeny}
        id={`${tableNm}-table-settings`}
      />

      <Modal
        onClose={() => onClose()}
        id={`${tableNm}-table-settings-modal`}
        theme={{
          '[role="dialog"]': { maxWidth: 'min-content', margin: 'auto' },
          '> div:first-of-type :focus': { outlineOffset: '0px !important' },
        }}
      >
        <ModalHeader id={`${tableNm}-table-settings-modal-header`}>
          <h2 id={`${tableNm}-table-settings-modal--header-title`} className="fluid heading-3">
            Table Settings
          </h2>
        </ModalHeader>

        <ModalBody
          id={`${tableNm}-table-settings-modal-body`}
          style={{ paddingTop: '20px' }}
          className="stack-a flex flex-column"
        >
          {error && (
            <Alert id={`${tableNm}-table-settings-modal-body-error`} style={{ marginLeft: '30px' }}>
              Internal Server Error while processing your request. Please try again.
            </Alert>
          )}

          {isMinOneActHeaderErr && (
          <Alert id={`${tableNm}-table-settings-modal-body-activeHeader-error`} style={{ marginLeft: '30px' }}>
            At least one column must be active for the table. Please try again.
          </Alert>
          )}
          {isExceedingLimitErr && (
            <Alert id={`${tableNm}-table-settings-modal-body-activeHeader-error`} style={{ marginLeft: '30px' }}>
              There cannot be more than 12 columns. You can add by swapping other columns.
            </Alert>
          )}

          <div
            id={`${tableNm}-table-settings-modal-body-multiselect-container`}
            style={{ marginLeft: '30px', marginRight: '90px' }}
          >
            <MultiItemSelect
              id={`${tableNm}-table-settings-modal-body-multiselect`}
              options={options}
              setOptions={setOptions}
              leftMenuTitle="AVAILABLE COLUMNS"
              rightMenuTitle="SELECTED COLUMNS"
              allowItemOrdering={true}
              theme={multiSelectStyle}
              onChange={onChangeOfMultiItem}
              onRightItemMove={onRightItemMove}
              onLeftItemMove={onLeftItemMove}
              showError={() => { setIsExceedingLimitErr(true); }}
            />
          </div>

          <div
            id={`${tableNm}-table-settings-modal-body-items-per-page`}
            style={{ marginLeft: '30px', marginRight: '90px' }}
          >
            RESULTS PER PAGE :
            <ItemsPerPageBadges
              id={`${tableNm}-table-settings-modal-body-items-per-page-badge`}
              itemsPerPage={itemsPerPage}
              onItemsPerPageChange={onItemsPerPageChange}
            />
          </div>

          {sortEnable && (
            <div
              id={`${tableNm}-table-settings-modal-body-table-sorting`}
              className="flex-inline stack-r"
              style={{ marginLeft: '30px', marginRight: '90px' }}
            >
              <div id={`${tableNm}-table-settings-modal-body-table-sorting-header`}>
                DATA TABLE SORTING :
              </div>
              <div
                id={`${tableNm}-table-settings-modal-body-table-sorting-order`}
                className="stack-r flex-inline"
              >
                {
                  (Array.isArray(sorting) && sorting.length > 0)
                  && sorting.map((ele) => (
                    /* eslint-disable-next-line react/jsx-key */
                    <Button
                      id={`${tableNm}-table-settings-modal-body-table-sorting-order-type-1`}
                      styleType={sortDirection === ele.name ? 'primary' : 'secondary'}
                      onClick={() => onSortDirectionChange(ele.name)}
                      size="sm"
                      style={{ width: '88px' }}
                    >
                      {ele.text}
                    </Button>
                  ))
                }
              </div>

              <div id={`${tableNm}-table-settings-modal-body-table-sorting-by-label`}>
                ( {sortByLabel} )
              </div>
            </div>
          )}
        </ModalBody>

        <ModalFooter id={`${tableNm}-table-settings-modal-footer`}>
          <div id={`${tableNm}-table-settings-modal-footer-container`}>
            <ButtonSecondary
              id={`${tableNm}-table-settings-modal-footer-reset-to-defaults`}
              className="margin-responsive-r"
              onClick={() => onResetToDefaultClick()}
            >
              Reset to Defaults
            </ButtonSecondary>
            <ButtonPrimary
              id={`${tableNm}-table-settings-modal-footer-save-settings`}
              onClick={() => onSave()}
              disabled={!changeFlag}
            >
              Save Settings
            </ButtonPrimary>
          </div>
        </ModalFooter>
      </Modal>
    </div>
  );
};

TableSettingsComponent.displayName = 'TableSettingsComponent';
export default TableSettingsComponent;
